import React from 'react';

const FixedLayoutEditorV2Page = React.lazy(() => import('../pages/fixedLayoutEditorV2/FixedLayoutEditorV2Page'));
const FixedLayoutEditorV2DemoPage = React.lazy(() => import('../pages/fixedLayoutEditorV2/FixedLayoutEditorV2DemoPage'));

export const PATH_FIXED_LAYOUT_EDITOR = '/fixedlayout-editor/:id';
export const PATH_FIXED_LAYOUT_EDITOR_DEMO = '/fixedlayout-editordemo/:id';

const PAGE_FIXED_LAYOUT_EDITOR = {
  component: FixedLayoutEditorV2Page,
  path: PATH_FIXED_LAYOUT_EDITOR,
};

const PAGE_FIXED_LAYOUT_EDITOR_DEMO = {
  component: FixedLayoutEditorV2DemoPage,
  path: PATH_FIXED_LAYOUT_EDITOR_DEMO,
};

// IMPORTANT: The order in which the pages are added is important
export default [PAGE_FIXED_LAYOUT_EDITOR, PAGE_FIXED_LAYOUT_EDITOR_DEMO];
